module.exports = __webpack_public_path__ + "static/media/italy-flag.92ea4443.png";